const C = require("../constants");

const comboDialog = (data) => {
    return {
        type: C.COMBO_DIALOG,
        data
    }
};

export {comboDialog};


// WEBPACK FOOTER //
// ./src/actions/ComboDialogActions.js